import { ElectronAPIsType } from "./types";

const ElectronAPIs: ElectronAPIsType = globalThis["ElectronAPIs"];

export default ElectronAPIs;
